var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M11.583 0v2.236H0V0h11.583zm0 5.764V8H0V5.764h11.583z","fill":"#000"}})}
var staticRenderFns = []

export { render, staticRenderFns }